module.exports = __webpack_public_path__ + "static/img/gzy.f62d4e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/myteam/gzy.png
// module id = f9jw
// module chunks = 1